import React, { useEffect, useRef, useState } from 'react'
import { apiData } from '../../../actions';
import { Helmet } from 'react-helmet-async';
import moment from 'moment';
import { useLocation } from 'react-router-dom';
import ExcitementSeeking from '../hotel/ExcitementSeeking';
import { Modal } from 'react-bootstrap';
import singleblogbg from '../../../assets/images/single-blog-bg.png'
export default function SingleBlogDemo() {
    const routePath = useLocation();

    const [blog, setBlog] = useState([]);
    const [place, setPlace] = useState("");
    const [seeMoreModal, setSeeMoreModal] = useState(false);
    const [dealsData, setDealsData] = useState([]);
    const [fullContentUrl, setFullContentUrl] = useState("");
    const [prevCity, setPrevCity] = useState("");

    const modalBodyRef = useRef(null);

    /* ================= API ================= */
    const Blog_details = async () => {
        const slug = routePath.pathname.split("/")[2];
        if (!slug) return;

        const apiRes = await apiData.single_Blog({ slug });

        if (apiRes?.status >= 200 && apiRes?.status <= 399) {
            const data = apiRes?.data?.data || [];
            setBlog(data);

            const city = data?.[0]?.city?.split(",")?.[0] || "";
            setPlace(city);

            /* ---------- Inclusive Deals ---------- */
            const apiRes1 = await apiData.inclusiveDeals({ city });
            const scriptContainer = document.getElementById("InclusiveScript");

            if (apiRes1?.status >= 200 && apiRes1?.status <= 399 && scriptContainer) {
                scriptContainer.innerHTML = "";

                const content =
                    apiRes1?.data?.data?.getYourGuide?.[0]?.content;

                const scriptUrl = content?.split('"')?.[1];
                if (scriptUrl) {
                    const script = document.createElement("script");
                    script.src = scriptUrl.replace(/(?<=items=)\d+/, "4");
                    scriptContainer.appendChild(script);

                    setFullContentUrl(
                        scriptUrl.replace(/(?<=items=)\d+/, "20")
                    );
                }
            }

            /* ---------- Hotels ---------- */
            const hotelRes = await apiData.getRandomDeals({
                city,
                keyword: "Hotels",
                limit: 4,
            });

            const hotelDiv = document.getElementById("hotel_stay");
            if (hotelDiv) hotelDiv.innerHTML = "";

            if (hotelRes?.status >= 200 && hotelRes?.status <= 399) {
                const content = hotelRes?.data?.data?.[0]?.content;
                if (content?.includes('"') && hotelDiv) {
                    const script = document.createElement("script");
                    script.src = content.split('"')[1];
                    hotelDiv.appendChild(script);
                }
            }

            /* ---------- Flights ---------- */
            const flightRes = await apiData.getRandomDeals({
                city,
                keyword: "Flights",
                limit: 4,
            });

            if (flightRes?.status >= 200 && flightRes?.status <= 399) {
                setDealsData(flightRes?.data?.data || []);
            }
        }
    };

    const handleSeeAllClick = async () => {
        setSeeMoreModal(true);

    }

    /* ================= EFFECTS ================= */
    useEffect(() => {
        Blog_details();
        window.scrollTo({ top: 0, behavior: "instant" });
    }, []);

    useEffect(() => {
        if (seeMoreModal && modalBodyRef.current && fullContentUrl) {
            modalBodyRef.current.innerHTML = "";
            const script = document.createElement("script");
            script.src = fullContentUrl;
            modalBodyRef.current.appendChild(script);
        }
    }, [seeMoreModal, fullContentUrl]);

    useEffect(() => {
        const visitedCities =
            JSON.parse(localStorage.getItem("visitedCities")) || [];
        const hasSeen = localStorage.getItem("hasSeenBlogPopup");

        if (!hasSeen || !visitedCities.includes(place)) {
            localStorage.setItem("hasSeenBlogPopup", "true");
            localStorage.setItem(
                "visitedCities",
                JSON.stringify([...visitedCities, place])
            );
        }

        if (place !== prevCity) setPrevCity(place);
    }, [place, prevCity]);

    return (
        <>
            <Helmet>
                <title>{blog && blog[0]?.seo_title}</title>
                <meta
                    name="keyword"
                    content={blog && blog[0]?.seo_keyword}
                />
                <meta
                    name="description"
                    content={blog && blog[0]?.seo_description}
                />
            </Helmet>

            <section className="section-equal-padding uk-scrollspy-inview"
                style={{ backgroundImage: `url(${singleblogbg})`, backgroundRepeat: "no-repeat", backgroundSize: "cover" }}
                uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: true">
                <div className="container">
                    <div className="slider-content text-center" style={{maxWidth:'100%'}}>
                        <h1 className="blogs_detail_heading">
                            {blog && blog[0]?.name}
                        </h1>
                        <p style={{ color: "#E5E5E5" }}>{moment(blog && blog[0]?.date).format(
                            "MMMM Do YYYY"
                        )}</p>
                    </div>
                </div>
            </section>

            <section className="blogs_detail_sec section-equal-padding bg-white">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-lg-8">
                            <div className="blog_left">
                                <img loading="lazy" src={blog && blog[0]?.image} alt=""
                                    uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: true" />
                                <div>

                                    <h2>{blog && blog[0]?.title}</h2>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: blog?.[0]?.post_content
                                                ?.replace(/&lt;/g, "<")
                                                .replace(/&gt;/g, ">")
                                                .replace(/&quot;/g, '"'),
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-12 col-lg-4">
                            <aside className="filter-resturante sidebar blog_sidebar">

                                <div className="recent-work mb-4"
                                    uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: true">
                                    <h6 className="filter-header mb-3">Hotels in {blog && blog[0]?.city}</h6>
                                    {/* <ul className="recent-list">
                                        <li>
                                            <img src="assets/images/discover-authentic-img.jpg" alt="thumb" />
                                            <div className="recent-info">
                                                <a href="#" className="recent-title">Aruba Travel Guide: Top Activities at One Happy
                                                    Island</a>
                                                <a href="#" className="read-more">Read More
                                                    <svg width=" 10" height="10" viewBox="0 0 10 10" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M0.833984 9.16671L9.16732 0.833374M9.16732 0.833374H0.833984M9.16732 0.833374V9.16671"
                                                            stroke="#626262" stroke-width="1.66667" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                    </svg>

                                                </a>
                                            </div>
                                        </li>
                                        <li>
                                            <img src="assets/images/discover-authentic-img.jpg" alt="thumb" />
                                            <div className="recent-info">
                                                <a href="#" className="recent-title">Savannah Travel Guide: Unveiling the City of
                                                    Squares</a>
                                                <a href="#" className="read-more">Read More <svg width=" 10" height="10"
                                                    viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M0.833984 9.16671L9.16732 0.833374M9.16732 0.833374H0.833984M9.16732 0.833374V9.16671"
                                                        stroke="#626262" stroke-width="1.66667" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                </svg>

                                                </a>
                                            </div>
                                        </li>
                                        <li>
                                            <img src="assets/images/discover-authentic-img.jpg" alt="thumb" />
                                            <div className="recent-info">
                                                <a href="#" className="recent-title">A Bahamas Travel Guide: Your Journey to Island
                                                    Bliss</a>
                                                <a href="#" className="read-more">Read More <svg width=" 10" height="10"
                                                    viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M0.833984 9.16671L9.16732 0.833374M9.16732 0.833374H0.833984M9.16732 0.833374V9.16671"
                                                        stroke="#626262" stroke-width="1.66667" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                </svg>
                                                </a>
                                            </div>
                                        </li>
                                        <li>
                                            <img src="assets/images/discover-authentic-img.jpg" alt="thumb" />
                                            <div className="recent-info">
                                                <a href="#" className="recent-title">Savannah Travel Guide: Unveiling the City of
                                                    Squares</a>
                                                <a href="#" className="read-more">Read More <svg width=" 10" height="10"
                                                    viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M0.833984 9.16671L9.16732 0.833374M9.16732 0.833374H0.833984M9.16732 0.833374V9.16671"
                                                        stroke="#626262" stroke-width="1.66667" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                </svg>
                                                </a>
                                            </div>
                                        </li>
                                    </ul> */}

                                    <div id="hotel_stay" className="d-flex flex-wrap overflow-auto" style={{ height: '600px' }}>

                                    </div>
                                </div>
                                <div className="recent-work mb-4"
                                    uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: true">
                                    <h6 className="filter-header mb-3">Flights in {blog && blog[0]?.city}</h6>
                                    <div id="deal-flight" className="d-flex flex-wrap overflow-auto" style={{ height: '600px' }}>
                                        {dealsData && dealsData.length > 0 ? (
                                            dealsData.map((ele) => (
                                                <div className='deal-fligh-divs' key={ele?.id}>
                                                    <div className="slider-block">
                                                        <a href={ele?.link} target="_blank" rel="noreferrer">
                                                            <img loading="lazy" src={`${ele?.image}`} alt='Flight-deals' />
                                                            <h6>{ele?.city_name} <i className="fa fa-plane flight_deal_icon" aria-hidden="true"></i> {blog && blog[0]?.city}</h6>
                                                        </a>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <div style={{ color: '#b2b2b2', padding: '10px', textAlign: 'center', width: '100%' }}>Flights not available or malformed.</div>
                                        )}
                                        {/* The script or warning will be injected here by JS if needed */}
                                    </div>
                                </div>
                            </aside>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-lg-12'>
                            <div id="InclusiveScript">

                            </div>
                            {fullContentUrl && fullContentUrl.length > 0 && (
                                <div className="d-flex justify-content-center mt-4 mb-4" >
                                    <button className="see-all-btn" onClick={handleSeeAllClick}>See All<i className="fa-solid fa-arrow-right"></i></button>
                                </div>

                            )}
                        </div>
                    </div>
                </div>

                <ExcitementSeeking />
                <div className="d-flex justify-content-between align-items-end my-4 border-top pt-4">

                    {/* Previous Article */}
                    {blog[0]?.prev_url && (
                        <div className="text-start" style={{ width: "100%" }}>
                            <a
                                href={`${blog[0]?.prev_url}`}
                                className="text-decoration-none"
                            >
                                <div className="text-uppercase small" style={{ letterSpacing: "2px", color: "#777" }}>
                                    <i className="fa-solid fa-chevron-left me-1"></i>
                                    Previous Blog
                                </div>

                                <div className="mt-2" style={{ color: "#000", fontWeight: "600", lineHeight: "1.4" }}>
                                    {blog[0]?.prev_title}
                                </div>
                            </a>
                        </div>
                    )}

                    {/* Next Article */}
                    {blog[0]?.next_url && (
                        <div className="text-end" style={{ width: "100%" }}>
                            <a
                                href={`${blog[0]?.next_url}`}
                                className="text-decoration-none"
                            >
                                <div className="text-uppercase small" style={{ letterSpacing: "2px", color: "#777" }}>
                                    Next Blog
                                    <i className="fa-solid fa-chevron-right ms-1"></i>
                                </div>

                                <div className="mt-2" style={{ color: "#000", fontWeight: "600", lineHeight: "1.4" }}>
                                    {blog[0]?.next_title}
                                </div>
                            </a>
                        </div>
                    )}

                </div>
            </section>


            <Modal
                show={seeMoreModal}
                onHide={() => setSeeMoreModal(false)}
                size="xl"
            >
                <Modal.Header closeButton>
                    <Modal.Title>All Tours</Modal.Title>
                </Modal.Header>
                <Modal.Body ref={modalBodyRef} />
            </Modal>
        </>
    )
}
